var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input materialReview", attrs: { type: "table" } },
    [
      _c("table", { ref: "table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(
            _vm.getMaterialTableRows(_vm.formValue),
            function (item, index) {
              return _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.dunName) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  item.primaryPackages.length > 0
                    ? _c(
                        "div",
                        _vm._l(item.secondaryPackages, function (secondary) {
                          return _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(secondary.name) +
                                " - (" +
                                _vm._s(secondary.quantity) +
                                " x " +
                                _vm._s(secondary.pmName) +
                                ")\n                        "
                            ),
                          ])
                        }),
                        0
                      )
                    : _c("div", [
                        _vm._v(
                          "\n                        Please associate dun to a secondary packaging\n                    "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  item.primaryPackages.length > 0
                    ? _c(
                        "div",
                        _vm._l(item.primaryPackages, function (primary) {
                          return _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(primary.name) +
                                " - (" +
                                _vm._s(primary.dfQuantity) +
                                " x " +
                                _vm._s(primary.dfName) +
                                ")\n                        "
                            ),
                          ])
                        }),
                        0
                      )
                    : _c("div", [
                        _vm._v(
                          "\n                        Please associate a primary package to a secondary package\n                    "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  item.dosageForms.length > 0
                    ? _c(
                        "div",
                        _vm._l(item.dosageForms, function (df) {
                          return _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(df.name) +
                                " - (" +
                                _vm._s(df.quantity) +
                                " x " +
                                _vm._s(df.unitName) +
                                ")\n                        "
                            ),
                          ])
                        }),
                        0
                      )
                    : _c("div", [
                        _vm._v(
                          "\n                        Please associate dosageform to a primary package.\n                    "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  item.apis.length > 0
                    ? _c(
                        "div",
                        _vm._l(item.apis, function (api) {
                          return _c("div", [
                            api.name !== ""
                              ? _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(api.name) +
                                      " - (" +
                                      _vm._s(api.quantity) +
                                      " x " +
                                      _vm._s(api.unitName) +
                                      ")\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        }),
                        0
                      )
                    : _c("div", [
                        _vm._v(
                          "\n                        Please associate dosageform to a primary package.\n                    "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  _vm._l(item.ancillaryEquipments, function (ancillary) {
                    return _c("div", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(ancillary.name) +
                          " x " +
                          _vm._s(ancillary.quantity) +
                          "\n                    "
                      ),
                    ])
                  }),
                  0
                ),
              ])
            }
          ),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("\n                    Dun\n                ")]),
        _vm._v(" "),
        _c("th", [_vm._v("\n                    Secondary\n                ")]),
        _vm._v(" "),
        _c("th", [_vm._v("\n                    Primary\n                ")]),
        _vm._v(" "),
        _c("th", [
          _vm._v("\n                    Dosageform\n                "),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("\n                    Api\n                ")]),
        _vm._v(" "),
        _c("th", [_vm._v("\n                    Ancillary\n                ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }